import React from 'react';
import { Table, Header, Form, Loader, Grid, Message, Divider } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';

import ThreeColumnTableRow from '../../../../../Admin/CreateCourse/ThreeColumnTableRow';
import Status from '../Status/Status';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class CandidateBasicInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            generalInfo: {},
            loader: true,

        };
        this.getCandidate = this.getCandidate.bind(this);
    }
    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');

        element[0].childNodes[1].classList.remove('segment');
        this.getCandidate();
    }

    getCandidate() {
        let candidateId = localStorage.getItem('candidateId');
        axios.get(`/equivalence/${candidateId}`)
            .then((res) => {
                let generalInfo = res.data;
                this.setState({ generalInfo, loader: false });
            })
            .catch(err => {
                console.log('Failed to fetch generalInfo of candidate.');
            });
    }


    render() {
        return (
            <div>
                <Status getCandidate={this.getCandidate}/>
                <Grid columns={2}>
                    <Grid.Column> <Divider horizontal>
                        <Header as="h4">
                            Osnovni podaci
                        </Header>
                    </Divider>
                        { this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active /> </div> : <Table celled unstackable compact>
                        {console.log('info', this.state.generalInfo)}
                        <Table.Body>
                                <ThreeColumnTableRow
                                name="Ime i prezime"
                                keyName="lastName"
                                value={this.state.generalInfo.firstName + ' ' + this.state.generalInfo.lastName}
                                onChange={this.onChange}
                                edit={this.state.edit}
                            />
                                <ThreeColumnTableRow
                                name="Datum podnošenja zahtjeva"
                                keyName="date"
                                value={moment(this.state.generalInfo.date).format('D. M. YYYY.')}
                                onChange={this.onChange}
                                edit={this.state.edit}
                            />
                                <ThreeColumnTableRow
                                name="Studijski program na koji se prebacuje"
                                keyName="optionalCoursesNumberMax"
                                value={this.state.generalInfo.targetStudyProgramName}
                                edit={this.state.edit}
                            />
                                <ThreeColumnTableRow
                                name="Semestar od kojeg započinje studij"
                                keyName="optionalCoursesNumberMax"
                                value={this.state.generalInfo.targetStudyProgramSemester}
                                edit={this.state.edit}
                            />
                                <ThreeColumnTableRow
                                name="Komisija"
                                keyName="optionalCoursesNumberMax"
                                value={this.state.generalInfo.committeeType + ' ' + this.state.generalInfo.committeeYear}
                                onChange={this.onChange}
                                edit={this.state.edit}
                            />
                                <ThreeColumnTableRow
                                name="Broj telefona"
                                keyName="optionalCoursesNumberMin"
                                value={this.state.generalInfo.phoneNumber}
                                onChange={this.onChange}
                                edit={this.state.edit}
                            />
                                <ThreeColumnTableRow
                                name="Email"
                                keyName="optionalCoursesECTSMin"
                                value={this.state.generalInfo.email}
                                onChange={this.onChange}
                                edit={this.state.edit}
                            />


                            </Table.Body>
                    </Table>}

                    </Grid.Column>
                    <Grid.Column>
                        <Divider horizontal>
                            <Header as="h4">
                                Podaci o prethodnom studiju
                            </Header>
                        </Divider>
                        {this.state.loader ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active /> </div> : <Table celled unstackable compact>

                            <Table.Body>
                                <ThreeColumnTableRow
                                    name="Univerzitet"
                                    keyName="optionalCoursesNumberMin"
                                    value={this.state.generalInfo.sourceUniversity}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                />

                                <ThreeColumnTableRow
                                    name="Organizaciona jedinica"
                                    keyName="optionalCoursesECTSMin"
                                    value={this.state.generalInfo.sourceOrganizationalUnit}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                />
                                <ThreeColumnTableRow
                                    name="Odsjek"
                                    keyName="optionalCoursesECTSMax"
                                    value={this.state.generalInfo.sourceDepartment}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                />

                                <ThreeColumnTableRow
                                    name="Smjer"
                                    keyName="optionalCoursesNumberMax"
                                    value={this.state.generalInfo.sourceStudyProgram}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                />
                                <ThreeColumnTableRow
                                    name="Index"
                                    keyName="optionalCoursesNumberMax"
                                    value={this.state.generalInfo.studentIdentificationNumber}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                />
                                <ThreeColumnTableRow
                                    name="Semestar"
                                    keyName="optionalCoursesNumberMax"
                                    value={this.state.generalInfo.sourceStudyProgramSemester}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                />
                                <ThreeColumnTableRow
                                    name="Tip studiranja"
                                    keyName="optionalCoursesNumberMax"
                                    value={this.state.generalInfo.sourceStudyType}
                                    onChange={this.onChange}
                                    edit={this.state.edit}
                                />


                            </Table.Body>
                        </Table>}

                    </Grid.Column>
                </Grid>


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CandidatesDetails/CandidateBasicInfo/CandidateBasicInfo.js